import { render, staticRenderFns } from "./F4.vue?vue&type=template&id=23b452c8&scoped=true"
import script from "./F4.vue?vue&type=script&lang=js"
export * from "./F4.vue?vue&type=script&lang=js"
import style0 from "./F4.vue?vue&type=style&index=0&id=23b452c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b452c8",
  null
  
)

export default component.exports